export const formatCurrency = (value, locale = 'en-US', currency = 'USD') => {
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Number(value || 0));
  } catch {
    return `$${Number(value || 0).toFixed(2)}`;
  }
};
